import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import WhoWeServe from "@/components/site/WhoWeServe";
import Process from "@/components/site/Process";
import FinalCTA from "@/components/site/FinalCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Landing = () => {
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <WhoWeServe />
        <Process />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
